import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Handles the Google (Emergent) OAuth return: reads #session_id=... and exchanges it for our JWT.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { authenticate } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const session_id = decodeURIComponent(match[1]);
    api.post("/auth/google/session", { session_id })
      .then(({ data }) => {
        authenticate(data.token, data.user);
        window.history.replaceState(null, "", "/");
        nav(data.user?.subscribed ? "/profiles" : "/subscribe");
      })
      .catch((err) => {
        toast.error(formatApiError(err.response?.data?.detail) || "Google sign-in failed");
        nav("/login");
      });
  }, [authenticate, nav]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="animate-spin text-brand mx-auto mb-3" size={40} />
        <p className="text-zinc-400 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
